import { Room } from '@eventr/common'
import { ColoursObj, Icon } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useFormatValue } from '../../hooks/useFormatValue'
import { useScreenTypeContext } from '../../state/screenTypeProvider'
import { useObjectContext } from '../providers/objectProvider'
import { CardText } from '../subComponents/cardText'
import { DisplayLabel } from '../subComponents/displayLabel'
interface HotelHeaderProps {
    name: string
    label: string
    room?: Room
    labelTime?: string
}
export const HotelHeader = ({
    name,
    label,
    room,
    labelTime,
}: HotelHeaderProps) => {
    const { past } = useObjectContext()
    const { screenType } = useScreenTypeContext()
    const { formatValue } = useFormatValue()

    return (
        <Stack direction={'row'} justifyContent={'space-between'}>
            <Stack direction={'row'} gap={'8px'}>
                <Icon
                    name={'Stays'}
                    iconColour={
                        past
                            ? ColoursObj.shades.shade2
                            : ColoursObj.core.secondary
                    }
                />
                <CardText variant="bodyBold">{name}</CardText>
            </Stack>
            {!['upNext', 'team', 'edit'].includes(screenType) && (
                <CardText variant="bodyBold">
                    {room?.checkIn ? formatValue(room.checkIn, 'date') : ''}
                </CardText>
            )}
            {screenType === 'upNext' && (
                <DisplayLabel label={label} labelTime={labelTime} />
            )}
        </Stack>
    )
}
